<div class="row align-items-center" (click)="closeDropDown()">
  <div class="col-md-12">
    <label *ngIf="(labelText?.length || 0) > 0">{{labelText}}</label>

    <div #menu class="d-flex justify-content-between location-selector-form"
      [ngClass]="{'disableSelector':selectorDisabled,'location-selector-focus' : selectorOpened}" id="ddlLocationy"
      (click)="locationClick()" (click)="$event.stopPropagation()" [title]="hoverText">
      <div class="selected-location">{{selectedLocationName == "NBA" ? ('_General_No_Branches_Text_' | translate ) : selectedLocationName}}</div>
      <div><em class="fas fa-chevron-down"></em></div>
    </div>
    <div class="location-tree-wrapper p-2" *ngIf="selectorOpened" (click)="$event.stopPropagation()">
      <location-selector-tree-view [locations]="locationHierachy.locations" [expandedKeys]="expandedKeys"
        [selectedLocationId]="selectedLocationId ?? 0" (closeEvent)="onItemSelected($event)"
        [dispatchStateEvent]="dispatchStateEvent">
      </location-selector-tree-view>
    </div>
  </div>
</div>